var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaskGroup2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 153,
    viewBox: "0 0 150 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint0_linear_2750_70527)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2750_70527)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2750_70527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint1_linear_2750_70527)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2750_70527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 43H32C29.2386 43 27 45.2386 27 48V153C27 155.761 29.2386 158 32 158H118C120.761 158 123 155.761 123 153V48C123 45.2386 120.761 43 118 43Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53H40C38.3431 53 37 54.3431 37 56C37 57.6569 38.3431 59 40 59H66C67.6569 59 69 57.6569 69 56C69 54.3431 67.6569 53 66 53Z",
    fill: "#E1EBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66 95H40C38.3431 95 37 96.3431 37 98C37 99.6569 38.3431 101 40 101H66C67.6569 101 69 99.6569 69 98C69 96.3431 67.6569 95 66 95Z",
    fill: "#E1EBFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108 68H42C39.7909 68 38 69.7909 38 72V82C38 84.2091 39.7909 86 42 86H108C110.209 86 112 84.2091 112 82V72C112 69.7909 110.209 68 108 68Z",
    stroke: "#1485FD",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108 109H42C39.2386 109 37 111.239 37 114V122C37 124.761 39.2386 127 42 127H108C110.761 127 113 124.761 113 122V114C113 111.239 110.761 109 108 109Z",
    fill: "#DFEAFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32C55.2091 32 57 30.2091 57 28C57 25.7909 55.2091 24 53 24C50.7909 24 49 25.7909 49 28C49 30.2091 50.7909 32 53 32Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32C77.2091 32 79 30.2091 79 28C79 25.7909 77.2091 24 75 24C72.7909 24 71 25.7909 71 28C71 30.2091 72.7909 32 75 32Z",
    fill: "#1485FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32C99.2091 32 101 30.2091 101 28C101 25.7909 99.2091 24 97 24C94.7909 24 93 25.7909 93 28C93 30.2091 94.7909 32 97 32Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88C88.7614 88 91 85.7614 91 83C91 80.2386 88.7614 78 86 78C83.2386 78 81 80.2386 81 83C81 85.7614 83.2386 88 86 88Z",
    fill: "#DFEAFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.907 104.37C89.107 104.37 88.36 104.37 87.68 104.327C86.8424 104.27 86.0366 103.984 85.3514 103.499C84.6661 103.014 84.1279 102.349 83.796 101.578L79.577 93.24C79.2675 92.8797 79.113 92.4117 79.1471 91.938C79.1812 91.4643 79.4011 91.0233 79.759 90.711C80.0521 90.4754 80.4178 90.3485 80.794 90.352C81.0709 90.3601 81.3427 90.4281 81.5908 90.5513C81.8389 90.6746 82.0573 90.8502 82.231 91.066L84.147 93.681L84.176 93.715V83.78C84.176 83.2871 84.3718 82.8144 84.7203 82.4659C85.0688 82.1173 85.5416 81.9215 86.0345 81.9215C86.5274 81.9215 87.0001 82.1173 87.3486 82.4659C87.6972 82.8144 87.893 83.2871 87.893 83.78V90.28C87.8714 90.0408 87.8999 89.7998 87.9766 89.5722C88.0533 89.3446 88.1766 89.1355 88.3386 88.9582C88.5006 88.781 88.6978 88.6394 88.9175 88.5425C89.1373 88.4456 89.3748 88.3956 89.615 88.3956C89.8551 88.3956 90.0926 88.4456 90.3124 88.5425C90.5321 88.6394 90.7293 88.781 90.8913 88.9582C91.0533 89.1355 91.1766 89.3446 91.2533 89.5722C91.3301 89.7998 91.3585 90.0408 91.337 90.28V91.635C91.3154 91.3958 91.3439 91.1548 91.4206 90.9272C91.4973 90.6996 91.6206 90.4905 91.7826 90.3132C91.9446 90.136 92.1418 89.9944 92.3615 89.8975C92.5813 89.8006 92.8188 89.7506 93.059 89.7506C93.2991 89.7506 93.5366 89.8006 93.7564 89.8975C93.9761 89.9944 94.1733 90.136 94.3353 90.3132C94.4973 90.4905 94.6206 90.6996 94.6973 90.9272C94.7741 91.1548 94.8025 91.3958 94.781 91.635V92.679C94.7594 92.4398 94.7879 92.1988 94.8646 91.9712C94.9413 91.7436 95.0646 91.5345 95.2266 91.3572C95.3886 91.18 95.5858 91.0384 95.8055 90.9415C96.0253 90.8446 96.2628 90.7946 96.503 90.7946C96.7431 90.7946 96.9806 90.8446 97.2004 90.9415C97.4201 91.0384 97.6173 91.18 97.7793 91.3572C97.9413 91.5345 98.0646 91.7436 98.1413 91.9712C98.2181 92.1988 98.2465 92.4398 98.225 92.679V99.016C98.191 100.965 97.31 104.251 94.211 104.251C93.986 104.261 92.08 104.371 89.911 104.371L89.907 104.37Z",
    fill: "#1485FD",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2750_70527",
    x: 21,
    y: 34,
    width: 108,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_70527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2750_70527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2750_70527",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2750_70527",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup2);
export default __webpack_public_path__ + "static/media/MaskGroup2.a10de59db9d3640b4681b404e3db8dce.svg";
export { ForwardRef as ReactComponent };